import gql from 'nanographql';
import Agent from "./Agent";

export default class OrderAgent extends Agent {

    async getOrder(code) {

        const query = gql`
            query OrderByCode($code: String!) {
                orderByCode(code: $code) {
                    id
                    code
                    customer {
                        emailAddress
                        user {
                            verified
                        }
                    }
                    customFields {
                        cancelable
                    }
                    orderPlacedAt
                    totalWithTax
                }
            }`;

        return this.send(query, {
            code
        }, "orderByCode");
    }

    async getMyReservations({ skip, take } = {}) {

        const query = gql`
            query MyReservations($skip: Int, $take: Int) {
                myReservations(options: { skip: $skip, take: $take }) {
                    totalItems
                    items {
                        orderLineId
                        orderId
                        orderCode
                        orderState
                        activityName
                        quantity
                        cancelled
                        cancelable
                        date
                        featuredAsset {
                            source
                        }
                        schedule {
                            from
                            to
                            utcOffset
                        }
                    }
                }
            }`;

        // Canal par défaut (pas de header vendure-token) pour agréger les
        // réservations de toutes les institutions. Le backend fait autorité sur
        // la propriété des lignes, sur le délai d'annulation (cancelable), sur
        // le tri et sur le plafond de "take".
        return this.send(query, {
            skip: skip ?? 0,
            take: take ?? null
        }, "myReservations", { skipToken: true });
    }

    async cancelReservation(orderLineId) {

        const query = gql`
            mutation CancelReservation($orderLineId: ID!) {
                cancelReservation(orderLineId: $orderLineId) {
                    success
                    errorCode
                }
            }`;

        return this.send(query, {
            orderLineId
        }, "cancelReservation", { skipToken: true });

    }

    async getReservationsByOrderCode(code) {

        const query = gql`
            query ReservationsByOrderCode($code: String!) {
                reservationsByOrderCode(code: $code) {
                    orderLineId
                    orderCode
                    orderState
                    activityName
                    quantity
                    cancelled
                    cancelable
                    date
                    featuredAsset {
                        source
                    }
                    schedule {
                        from
                        to
                        utcOffset
                    }
                }
            }`;

        // Canal par défaut (pas de header vendure-token) : le visiteur arrive
        // d'un e-mail et ne porte aucun jeton d'institution. Les commandes
        // appartiennent aussi au canal par défaut, d'où la résolution possible.
        // Le backend fait autorité sur l'accès (le code vaut justificatif),
        // sur "cancelable" et sur le tri.
        return this.send(query, {
            code
        }, "reservationsByOrderCode", { skipToken: true });
    }

    async cancelReservationByCode(code, orderLineId) {

        const query = gql`
            mutation CancelReservationByCode($code: String!, $orderLineId: ID!) {
                cancelReservationByCode(code: $code, orderLineId: $orderLineId) {
                    success
                    errorCode
                }
            }`;

        return this.send(query, {
            code,
            orderLineId
        }, "cancelReservationByCode", { skipToken: true });
    }

}
